import L from "leaflet";

const deviceIcon = L.divIcon({
  className: "k2",
  html: `<div class="custom-icon"> </div>`,
});

export default deviceIcon;
